import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, shareReplay, BehaviorSubject } from 'rxjs';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { environment } from 'src/environments/environment';
import { ValidateDocumentResponse } from 'src/app/shared/interfaces/validate-document-response.interface';

interface MaintenanceStatusResponse {
  onMaintenanceMode: boolean;
  publicKey?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {

  private http = inject(HttpClient);
  private loading = inject(LoadingService);

  private apiUrl = environment.baseUrl;

  private maintenanceStatusCheck$: Observable<boolean> | undefined;
  private publicKeySubject = new BehaviorSubject<string | null>(null);
  public publicKey$ = this.publicKeySubject.asObservable();

  checkMaintenanceStatus(): Observable<boolean> {
    if (!this.maintenanceStatusCheck$) {
      this.loading.show();
      this.maintenanceStatusCheck$ = this.http.get<MaintenanceStatusResponse>(this.apiUrl + 'health').pipe(
        map(response => {
          this.loading.hide();
          if (response.publicKey) {
            this.publicKeySubject.next(response.publicKey);
          }
          return response.onMaintenanceMode;
        }),
        catchError(error => {
          this.loading.hide();
          console.error('Error fetching maintenance status:', error);
          return of(false);
        }),
        shareReplay(1)
      );
    }
    return this.maintenanceStatusCheck$;
  }

  validateDocument(token: string, document: string): Observable<ValidateDocumentResponse> {
    const params = {
      tokenCaptcha: token,
      documentNumber: document,
    };

    return this.http.post<ValidateDocumentResponse>(this.apiUrl + 'validation', params);
  }
  
  forceCheckMaintenanceStatus(): Observable<boolean> {
    this.maintenanceStatusCheck$ = undefined;
    return this.checkMaintenanceStatus();
  }

  /**
   * Obtiene la llave pública almacenada
   * @returns string | null
   */
  getPublicKey(): string | null {
    return this.publicKeySubject.value;
  }

  /**
   * Obtiene la llave pública como Observable
   * @returns Observable<string | null>
   */
  getPublicKey$(): Observable<string | null> {
    return this.publicKey$;
  }
}
